var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Offer"},[_c('div',{staticClass:"Offer__image"},[_c('img',{attrs:{"src":require(("@/assets/images/icons/" + _vm.imgID + ".svg"))}})]),_c('div',{staticClass:"Offer__title"},[_c('h5',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }